// src/service/websocket.js

import { store } from "../Redux/Store";
import { setWebSocketData } from "../Redux/service/Websocket";
import { throttle } from "lodash";

class WebSocketManager {
	constructor() {
		this.socket = null;
		this.tasks = null;
		this.accumulatedData = {
			devices: [],
			positions: [],
			events: [],
		};

		// Throttled dispatch to reduce frequency of Redux updates
		this.throttledDispatch = throttle(() => {
			if (
				this.accumulatedData.devices.length === 0 &&
				this.accumulatedData.positions.length === 0 &&
				this.accumulatedData.events.length === 0
			) {
				return; // Nothing to dispatch
			}

			// Deduplicate by deviceId
			const uniqueDevices = new Map();
			for (const device of this.accumulatedData.devices) {
				uniqueDevices.set(device.id, device);
			}

			const uniquePositions = new Map();
			for (const pos of this.accumulatedData.positions) {
				uniquePositions.set(pos.deviceId, pos);
			}

			const uniqueEvents = new Map();
			for (const event of this.accumulatedData.events) {
				uniqueEvents.set(event.deviceId, event);
			}
			// Dispatch the merged & deduplicated data
			store.dispatch(
				setWebSocketData({
					devices: Array.from(uniqueDevices.values()),
					positions: Array.from(uniquePositions.values()),
					events: Array.from(uniqueEvents.values()),
				}),
			);

			// Clear buffer after dispatch
			this.accumulatedData = {
				devices: [],
				positions: [],
				events: [],
			};
		}, 800); // 500ms throttle
	}

	connect() {
		this.socket = new WebSocket(process.env.REACT_APP_WSSOCKET_URL);

		this.socket.onopen = () => {
			console.log("WebSocket connected");
		};

		this.socket.onmessage = (event) => {
			const parsedData = JSON.parse(event.data);

			if (parsedData.devices?.length) {
				this.accumulatedData.devices.push(...parsedData.devices);
			}
			if (parsedData.positions?.length) {
				this.accumulatedData.positions.push(...parsedData.positions);
			}
			if (parsedData.events?.length) {
				this.accumulatedData.events.push(...parsedData.events);
			}

			// Call throttled dispatch
			this.throttledDispatch();
		};

		this.socket.onclose = () => {
			console.log("WebSocket disconnected");
		};

		this.socket.onerror = (error) => {
			console.error("WebSocket error:", error);
		};
	}

	disconnect() {
		if (this.socket) {
			this.socket.close();
		}
	}
}

export const webSocketManager = new WebSocketManager();
